<div class="modal-header">
    <h2 class="modal-title" translate>lblSavedFilters</h2>
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">×</span>
  </button>
</div>

<div class="modal-body">
    <div class="popup-vcenter">
        <div class="flgrow">
            <ng-container>
                <div class="card">
                    <div class="table-responsive">
                        <table class="tablest1">
                            <thead>
                                <tr>
                                    <th id="SearchName" scope="col" translate>lblSearchName</th>
                                    <th id="ParameterValues" scope="col" translate>
                                        lblParameterValues
                                    </th>
                                    <th id="Actions" scope="col" style="width: 75px" class="text-center" translate>
                                        lblAction
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="searchList?.length > 0; else load_NotFound_Search">
                                    <tr *ngFor="let Search of searchList; let i = index" (click)="selectedSaveSearch = Search.filterName">
                                        <td>
                                            <div class="">
                                                <input name="Search" type="radio" [(ngModel)]="selectedSaveSearch" [value]="Search.filterName" class="radio-custom" />
                                                <span class="ml-2">{{
                          Search.filterName
                        }}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <span class="mr-4" *ngFor="let item of Search.saveSearchArray">
                        <strong>{{ item.searchColumnName | translate }}</strong>
                        : {{ item.searchActualValue }}
                      </span>
                                        </td>
                                        <td class="text-center" style="width:100px">
                                            <div class="d-flex align-items-center">
                                                <button type="submit" class="btn btn-primary" (click)="onRun(Search.filterName); onClose()" translate aria-label="Center Align">
                          lblRun
                        </button>
                                                <span class="ico-div mx-3" style="height: 20px"></span>
                                                <em class="far fa-trash-alt fa-lg" ngbTooltip="{{'lblDelete' | translate}}" container="body" tooltipClass="custom-revert" (click)="onDeleteClick(Search.filterName)"></em>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                                <ng-template #load_NotFound_Search>
                                    <tr>
                                        <td colspan="8" class="no-record" translate>
                                            lblNoRecordsFound
                                        </td>
                                    </tr>
                                </ng-template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="submit" [disabled]="!selectedSaveSearch" class="btn btn-primary mr-sm-2" (click)="onEditOrApply()" translate aria-label="Center Align">
                {{ "lblEdit" }}
    </button>
    <button type="submit" class="btn btn-primary mr-sm-2" (click)="onResetClick(); onClose()" translate aria-label="Center Align">
    lblReset
  </button>
    <button (click)="onClose()" class="btn btn-secondary" aria-label="Center Align" translate>
    lblCancel
  </button>
</div>